import React, { useLayoutEffect, useState } from 'react';
import cn from 'classnames';
import { isEqual } from 'lodash';
import style from './index.module.scss';

const CustomKeyboard = props => {
  const layouts = {
    text: {
      default: [
        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
        '{tab} q w e r t y u i o p [ ] \\',
        "{lock} a s d f g h j k l ; ' {enter}",
        '{shift} z x c v b n m , . / {shift}',
        '.com {alt} @ {space} {done}',
      ],
      shift: [
        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
        '{tab} Q W E R T Y U I O P { } |',
        '{lock} A S D F G H J K L : " {enter}',
        '{shift} Z X C V B N M < > ? {shift}',
        '.com {alt} @ {space} {done}',
      ],
      alt: [
        '@ # & * - + = ( ) {bksp}',
        '{tab} 1 2 3 4 5 6 7 8 9 0 \\',
        '% ^ ~ | [ ] < > { } {enter}',
        '{shift} _ $ " , : ; . ? / {shift}',
        '.com {default} {space} {done}',
      ],
    },
    textWithOutDone: {
      default: [
        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
        '{tab} q w e r t y u i o p [ ] \\',
        "{lock} a s d f g h j k l ; ' {enter}",
        '{shift} z x c v b n m , . / {shift}',
        '.com {alt} @ {space}',
      ],
      shift: [
        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
        '{tab} Q W E R T Y U I O P { } |',
        '{lock} A S D F G H J K L : " {enter}',
        '{shift} Z X C V B N M < > ? {shift}',
        '.com {alt} @ {space}',
      ],
      alt: [
        '@ # & * - + = ( ) {bksp}',
        '{tab} 1 2 3 4 5 6 7 8 9 0 \\',
        '% ^ ~ | [ ] < > { } {enter}',
        '{shift} _ $ " , : ; . ? / {shift}',
        '.com {default} {space}',
      ],
    },

    surveyText: {
      // default: [
      //   '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      //   'q w e r t y u i o p [ ] \\',
      //   'a s d f g h j k l ; \' {surveyBack}',
      //   '{shift} z x c v b n m , . / {shift}',
      //   '.com {alt} @ {space} {done}'
      // ],
      default: [
        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
        'q w e r t y u i o p [ ] \\',
        "a s d f g h j k l ; ' {surveyBack}",
        '{shift} z x c v b n m , . / {shift}',
        '.com {alt} @ {space} {done}',
      ],
      // shift: [
      //   '` ~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      //   'Q W E R T Y U I O P { } |',
      //   'A S D F G H J K L : " {surveyBack}',
      //   '{shift} Z X C V B N M < > ? {shift}',
      //   '.com {alt} @ {space} {done}'
      // ],
      shift: [
        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
        'Q W E R T Y U I O P { } |',
        'A S D F G H J K L : " {surveyBack}',
        '{shift} Z X C V B N M < > ? {shift}',
        '.com {alt} @ {space} {done}',
      ],
      alt: [
        '@ # & * - + = ( ) {bksp}',
        '1 2 3 4 5 6 7 8 9 0 \\',
        '% ^ ~ | [ ] < > { } {surveyBack}',
        '{shift} _ $ " , : ; . ? / {shift}',
        '.com {default} {space} {done}',
      ],
    },

    number: {
      numericAlpha: ['1 2 3', '4 5 6', '7 8 9', '{default} 0 {bksp}', '{done}'],
      numericDefault: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {done}'],
      numericDot: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 .'],
      numericWithDotClear: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 .'],
      numericDefaultWithDot:
        props.isDot && !props.typed?.includes('.')
          ? ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp} {done}']
          : ['1 2 3', '4 5 6', '7 8 9', '0 {bksp} {done}'],
      numericShift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}'],
      numericSwipe: ['1 2 3', '4 5 6', '7 8 9', '{swipe} 0 {bksp}'],
      numeric: props.isClr
        ? ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 00']
        : ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 '],
      numericDefaultWithoutDone:
        props.isDot && !props.typed?.includes('.')
          ? ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}']
          : ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
    },
  };

  const returnLayout = value => {
    switch (value) {
      case 'text':
        return layouts.text.default;
      case 'surveyText':
        return layouts.surveyText.default;
      case 'textWithOutDone':
        return layouts.textWithOutDone.default;
      case 'number':
        return layouts.number.numericDefault;
      case 'numericAlpha':
        return layouts.number.numericAlpha;
      case 'swipe':
        return layouts.number.numericSwipe;
      case 'numeric':
        return layouts.number.numeric;
      case 'dot':
        return layouts.number.numericDefaultWithDot;
      case 'withoutDone':
        return layouts.number.numericDefaultWithoutDone;
      case 'numericWithDot':
        return layouts.number.numericWithDotClear;
      case 'numericDot':
        return layouts.number.numericDot;
      default:
        return layouts.text.default;
    }
  };

  const [layout, setLayout] = useState(returnLayout(props.type));
  const onclick = f => {
    switch (f) {
      case '{swipe}':
        return (
          props.auth.serverAppFeatures.supportsLoginUsingCard &&
          props.goToSwipe()
        );
      case '{space}':
      case '{tab}':
        return props.onClickBtn('  ');
        case '{done}': return props?.isAlphaNumericFlag ? (props?.setIsDoneClick(true), props?.closeKeyboard()) : props?.closeKeyboard();
      case '{enter}':
        return props?.closeKeyboard();
      case '{surveyBack}':
        return props?.closeKeyboard();
      default:
        return props.onClickBtn(f);
    }
  };

  const handleClick = f => {
    if (
      (props.type === 'text' ||
        isEqual(layout, layouts.text.default) ||
        isEqual(layout, layouts.text.shift)) &&
      (f === '{shift}' || f === '{lock}')
    ) {
      setLayout(
        isEqual(layout, layouts.text.shift)
          ? layouts.text.default
          : layouts.text.shift
      );
    } else if (
      (props.type === 'text' ||
        isEqual(layout, layouts.text.default) ||
        isEqual(layout, layouts.text.alt) ||
        isEqual(layout, layouts.text.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.text.alt)
          ? layouts.text.default
          : layouts.text.alt
      );
    } else if (
      (props.type === 'surveyText' ||
        isEqual(layout, layouts.surveyText.default) ||
        isEqual(layout, layouts.surveyText.shift)) &&
      f === '{shift}'
    ) {
      setLayout(
        isEqual(layout, layouts.surveyText.shift)
          ? layouts.surveyText.default
          : layouts.surveyText.shift
      );
    } else if (
      (props.type === 'surveyText' ||
        isEqual(layout, layouts.surveyText.default) ||
        isEqual(layout, layouts.surveyText.alt) ||
        isEqual(layout, layouts.surveyText.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.surveyText.alt)
          ? layouts.surveyText.default
          : layouts.surveyText.alt
      );
    } else if (
      (props.type === 'textWithOutDone' ||
        isEqual(layout, layouts.textWithOutDone.default) ||
        isEqual(layout, layouts.textWithOutDone.shift)) &&
      (f === '{shift}' || f === '{lock}')
    ) {
      setLayout(
        isEqual(layout, layouts.textWithOutDone.shift)
          ? layouts.textWithOutDone.default
          : layouts.textWithOutDone.shift
      );
    } else if (
      (props.type === 'textWithOutDone' ||
        isEqual(layout, layouts.textWithOutDone.default) ||
        isEqual(layout, layouts.textWithOutDone.alt) ||
        isEqual(layout, layouts.textWithOutDone.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.textWithOutDone.alt)
          ? layouts.textWithOutDone.default
          : layouts.textWithOutDone.alt
      );
    } else if (
      (props.type === 'number' || props.type === 'numericAlpha') &&
      f === '{default}'
    ) {
      props.setKeyboardType('text');
      setLayout(layouts.text.default);
    } else if (
      (Number(props.maxLength) > 0 &&
        props.typed?.length < Number(props.maxLength)) ||
      f === '{done}' ||
      f === '{bksp}' ||
      f === '{default}' ||
      f === '{lock}' ||
      f === '{shiftActivated}' ||
      f === '{shift}'
    ) {
      onclick(f);
    } else if (!props.maxLength) {
      onclick(f);
    }
  };

  const display = {
    '{alt}': props.type ==='surveyText' ? '!#1' : '?123',
    '{smileys}': '\uD83D\uDE03',
    '{shift}': '⇧',
    '{tab}': 'Tab',
    '{shiftactivated}': '⇧',
    '{enter}': 'return',
    '{bksp}': '⌫',
    '{altright}': '.?123',
    '{downkeyboard}': '🞃',
    '{space}': ' ',
    '{default}': 'ABC',
    '{back}': '⇦',
    '{lock}': 'Caps',
    '{swipe}':
      props.type === 'swipe' &&
      props.auth.serverAppFeatures.supportsLoginUsingCard
        ? '💳'
        : '',
    '{done}': 'Done',
    '{clear}': 'CLR',
    '{surveyBack}': '⇦',
  };

  const returnWidth = key => {
    switch (key) {
      case '{space}':
        return 'w-100';
      case '{alt}':
        return 'w-25';
      case '{default}':
        return 'w-25';
      case '@':
        return 'w-15';
      case '{done}':
        return props.type === 'number' ||
          props.type === 'numericAlpha' ||
          props.type === 'numeric' ||
          props.type === 'swipe'
          ? 'w-100'
          : 'w-20';
      default:
        return 'w-12';
    }
  };

  const returnBtnSize = () => {
    if (props.isPaymentApp) {
      return 'btn35';
    } else {
      return props.btnSize;
    }
  };

  const returnKeyboard = (e, index) => {
    const topLeft = index === 0;
    const topRight = index === 3;
    return (
      <>
        {e?.split(' ').length > 0 &&
          e.split(' ').map((f, i) => (
            <button
              key={Number(i)}
              className={cn(
                props?.cashIn ? "d-flex justify-content-center align-items-center rounded" : "",
                !props?.cashIn ? ((props.type === 'number' ||
                  props.type === 'withoutDone' ||
                  props.type === 'numericAlpha' ||
                  props.type === 'numeric' ||
                  props.type === 'swipe') &&
                  !(
                    isEqual(layout, layouts.text.default) ||
                    isEqual(layout, layouts.text.shift) ||
                    isEqual(layout, layouts.text.alt)
                  )
                  ? props.btnSize
                  : returnBtnSize()) : "",
                i%3 === 2 ? 'px-1 py-1' :'px-1 py-1 mr-1',
                props?.cashIn ? ((f === "1" || f === "2" || f === "3") ? "mt-2" : "mt-1") : "h-100 mt-1",
                props?.cashIn ? style.cashInKeyStyles : style.keyStyles,
                props.keyFontSize? style.keyFont38 : style.keyFont18,
                index > 3 ? returnWidth(f) : 'w-100',
                props.type !== 'text' && style.lineHeight_btn,
                topLeft ? style.cornerButtonTop : '',
                topRight ? style.cornerButtonButtom : '',
                (props.buttonTheme ? '' : '') || ''
              )}
              type="button"
              style={{height: props?.cashIn && props?.btnHeight}}
              onClick={() => handleClick(f)}
            >
              {display[f] ? display[f] : f === '{swipe}' ? '' : f}
            </button>
          ))}
      </>
    );
  };

  const returnFontSize = () => {
    if (props.customClass.includes('fs')) {
      return props.customClass;
    }
    return style.fontSize;
  };

  useLayoutEffect(() => {
    setLayout(returnLayout(props.type));
  }, [props.type, props.typed.includes('.')]);

  return (
    <div
      className={cn(
        props?.cashIn
          ? `col-12 m-0 h-100 px-2 ${style.border} ${returnFontSize()} ${props.customClass}`
          : `col-12 p-0 m-0 h-100 ${style.border} ${returnFontSize()} ${style.backgroundColour
          } ${props.customClass}`
      )}
      style={{ background: props?.cashIn && "#CACDD4" }}
    >
      {layout?.length > 0 &&
        layout?.map((e, index) => (
          <div
            key={Number(index)}
            className={cn(
              props.type === 'number' ||
                props.type === 'numericAlpha' ||
                props.type === 'numeric' ||
                props.type === 'swipe'
                ? 'col-12'
                : 'col',
              index > 3 && 'col-12',
              'd-flex px-0'
            )}
          >
            {returnKeyboard(e, index)}
          </div>
        ))}
    </div>
  );
};

export default CustomKeyboard;
